import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { I18nUtils } from '../../../i18n/I18nUtils';
import * as userAdminCopyCompanies from '../actions/userAdminCopyCompaniesActions';
import { bindActionCreators } from 'redux';
import UserRole from '../../shared/model/UserRole';
import Loadable from 'react-loading-overlay';

class UserAdminCopyCompaniesModal extends React.Component {

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ( ( prevProps.show !== this.props.show ) && this.props.show ) {
            this.props.userAdminCopyCompaniesActions.getUsers();
        }
    }

    render() {
        return (
            <div>
                <Modal
                    show={this.props.show}
                    onHide={this.props.onHide}
                    bsSize="large"
                    aria-labelledby="contained-modal-title-lg"
                >
                    <Loadable
                        active={this.props.loading}
                        spinner
                        text={I18nUtils.tr('TR_CARGANDO')}
                        background={'rgba(255,255,255,.9)'}
                        color={'rgb(0,0,0)'}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-lg">
                                {this.props.title}<br/>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-xs-12">

                                    {/*<UserAutocomplete*/}
                                    {/*user={this.props.user}*/}
                                    {/*id={'UserAdminCopyCompanies'}*/}
                                    {/*onChange={(value) => {*/}
                                    {/*if (value && value[0]){*/}
                                    {/*this.props.userAdminCopyCompaniesActions.setUser(value[0])*/}
                                    {/*}*/}
                                    {/*}}*/}
                                    {/*/>*/}
                                    <div className="form-group">
                                        <label>{I18nUtils.tr('TR_GESTOR')}</label>
                                        <select
                                            className={'form-control show-tick bootstrap-select'}
                                            value={this.props.user ? this.props.user.id : -1}
                                            onChange={(e) => {
                                                if ( -1 === parseInt(e.target.value, 10) ) {
                                                    this.props.userAdminCopyCompaniesActions.setUser(null);
                                                } else {
                                                    this.props.users.forEach((user) => {
                                                        if ( user.id === parseInt(e.target.value, 10) ) {
                                                            this.props.userAdminCopyCompaniesActions.setUser(user);
                                                        }
                                                    });
                                                }
                                            }}
                                        >
                                            <option key={-1} value={-1}/>
                                            {this.props.users.map((user, i) => {
                                                return ( <option key={i}
                                                                 value={user.id}>{`${user.name} ${user.last_name}`}</option> );
                                            })}
                                        </select>
                                    </div>

                                </div>
                            </div>
                            {this.renderSelectCompanies()}
                            <hr/>
                            <div className="row">
                                <div className="col-xs-12 text-right p-b-20">
                                    <button
                                        className="btn btn-lg btn-primary waves-effect"
                                        disabled={this.props.user === null || this.props.companySelectedIds.length === 0}
                                        onClick={() => {
                                            const companies = this.props.user.roles
                                                                  .filter((role) => role.role.id === UserRole.OUTSOURCES_MANAGER && this.props.companySelectedIds.indexOf(role.company.id) > -1)
                                                                  .map((role) => role.company);
                                            this.props.onAddCompanies(companies);
                                            this.props.userAdminCopyCompaniesActions.clear();
                                        }}
                                    >
                                        <i className="material-icons">import_export</i>
                                        <span>{I18nUtils.tr('TR_IMPORTAR_SUBCONTRATAS')}</span>
                                    </button>
                                </div>
                            </div>
                        </Modal.Body>
                    </Loadable>
                </Modal>
            </div>
        );
    }

    renderSelectCompanies() {
        const {
            user,
            companySelectedIds,
            userAdminCopyCompaniesActions,
        } = this.props;

        if ( user === null ) {
            return null;
        }

        if ( user.roles.every((role) => role.role.id !== UserRole.OUTSOURCES_MANAGER) ) {
            return (
                <div className="row">
                    <div className="col-xs-12 p-t-20">
                        <p className={'text-error'}>{I18nUtils.tr('TR_EL_USUARIO_SELECCIONADO_NO_ES_GESTOR_DE_USUARIOS')}</p>
                    </div>
                </div>
            );
        }

        const companies = [];
        const userRoles = user.roles
                              .filter(role => {
                                  return role.company && role.company.id !== user.my_company.id;
                              });
        userRoles.forEach((role, i) => {
            if ( role.role.id === UserRole.OUTSOURCES_MANAGER ) {
                companies.push(role.company);
            }
        });
        companies.sort((companyA, companyB) => {
            if ( companyA.name < companyB.name ) {
                return -1;
            }
            if ( companyA.name > companyB.name ) {
                return 1;
            }
            return 0;
        });

        return (
            <div>
                <div className="row">
                    <div className="col-xs-12 p-b-20 p-t-20">
                        <p>{I18nUtils.tr('TR_SELECCIONA_LAS_SUBCONTRATAS_QUE_QUIERAS_IMPORTAR')}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="check-all-wrap">
                            <input
                                type="checkbox"
                                id="check-all"
                                className="filled-in chk-col-blue-grey"
                                checked={userRoles.every((role) => companySelectedIds.indexOf(
                                    ( role.company && role.company.id ) || ( role.contractor && role.contractor.id ),
                                ) > -1)}
                                onChange={(e) => {
                                    if ( e.target.checked ) {
                                        const ids = userRoles.map((role) => {
                                            if ( role.role.id === UserRole.OUTSOURCES_MANAGER ) {
                                                return role.company.id;
                                            }
                                            return undefined;
                                        });
                                        userAdminCopyCompaniesActions.selectedAll(ids);
                                    } else {
                                        userAdminCopyCompaniesActions.unselectedAll();
                                    }
                                }}
                            />
                            <label htmlFor="check-all">{I18nUtils.tr('TR_MARCAR_TODAS')}</label>
                        </div>
                    </div>
                </div>
                <ul className="row list-unstyled">
                    {
                        companies.map((company, i) => {
                            return (
                                <li className="col-sm-6 import-list" key={i}>
                                    <input
                                        type="checkbox"
                                        id={`copy-company-${company.id}`}
                                        className="filled-in chk-col-blue-grey"
                                        checked={companySelectedIds.indexOf(company.id) > -1}
                                        onChange={(e) => {
                                            if ( e.target.checked ) {
                                                userAdminCopyCompaniesActions.addSelectedCompanyId(company.id);
                                            } else {
                                                userAdminCopyCompaniesActions.removeSelectedCompanyId(company.id);
                                            }
                                        }}
                                    />
                                    <label htmlFor={`copy-company-${company.id}`}>{company.name}</label>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    let userOptions = state.userAdminCopyCompanies.users;
    if ( props.selectedUserId && props.selectedUserId.toString().length !== 0 ) {
        userOptions = state.userAdminCopyCompanies.users.filter(user => user.id !== props.selectedUserId);
    }

    return ( {
        user: state.userAdminCopyCompanies.user,
        users: userOptions,
        companySelectedIds: state.userAdminCopyCompanies.companySelectedIds || [],
        loading: state.userAdminCopyCompanies.loading,
    } );
};

const mapDispatchToProps = dispatch => ( {
    userAdminCopyCompaniesActions: bindActionCreators(userAdminCopyCompanies, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(UserAdminCopyCompaniesModal);

UserAdminCopyCompaniesModal.propTypes = {
    title: PropTypes.string.isRequired,
    show: PropTypes.bool,
    onHide: PropTypes.func,
    onAddCompanies: PropTypes.func.isRequired,
    selectedUserId: PropTypes.number,
};

UserAdminCopyCompaniesModal.defaultProps = {
    show: false,
};



// WEBPACK FOOTER //
// ./src/app/users/components/UserAdminCopyCompaniesModal.js